<template>
  <div class="comment-item">
    <div v-if="!props.isAppend"
         class="item-spu">
      <div>
        <div ref="bigContainer"
             class="hidden"></div>
        <div v-if="props.item.is_custom"
             class="viewer">
          <image-customize-viewer v-if="props.item && bigContainer"
                                  :id="props.item.id + ''"
                                  mode="view"
                                  :container="bigContainer"
                                  :template-basic-parameters="templateBasicParameters(props.item)"
                                  :custom-area="assignCustomizedData(props.item)"
                                  :customized-image="renderImageCustomUrl(props.item)" />
        </div>
        <img v-else
             :src="toUrl(props.item.image)"
             class="viewer" />
      </div>
      <div class="spu-name">{{ props.item.spu_name }}</div>
    </div>
    <div class="item-form">
      <a-form :model="comment_form"
              name="basic"
              autocomplete="off">
        <a-form-item v-if="!props.isAppend"
                     :label="$t('Comment.CommentItem.overallRating')"
                     name="rate">
          <a-rate v-model:value="comment_form.rate" />
          <div class="rate-title"
               :class="rate_title.color">{{ rate_title.title }}</div>
        </a-form-item>
        <a-form-item :label="!props.isAppend ? $t('Comment.CommentItem.productReview') : $t('Comment.CommentItem.additionalReview')"
                     name="content">
          <a-textarea v-model:value="comment_form.content"
                      :placeholder="$t('Comment.CommentItem.placeholder')"
                      maxlength="300"
                      :rows="4" />
          <div style="display: flex;align-items: flex-end;">
            <a-upload v-model:file-list="fileList"
                      list-type="picture-card"
                      :with-credentials="true"
                      :max-count="5"
                      :action="toUrl('/v1/api/attachment/material')"
                      class="item-upload"
                      :before-upload="verifyUploadImgName"
                      @change="handleChange"
                      @preview="handlePreview">
              <div>
                <loading-outlined v-if="imgLoading"></loading-outlined>
                <plus-outlined />
                <div style="margin-top: 8px">{{ $t('Comment.CommentItem.uploadImage') }}</div>
              </div>
            </a-upload>
            <div class="upload-tip">{{ $t('Comment.CommentItem.uploadTip') }}</div>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
  <div style="display: flex;justify-content: flex-end;align-items: center;">
    <a-radio v-if="!props.isAppend"
             v-model:checked="comment_form.is_anonymous"
             @click="changeRadio">{{ $t('Comment.CommentItem.anonymousReview') }}</a-radio>
    <a-button type="primary"
              class="comment-btn"
              @click="submitComment">{{ $t('Comment.CommentItem.submitReview') }}</a-button>
  </div>
  <a-divider v-if="props.isDivider" />
  <a-modal v-model:visible="previewVisible"
           :title="previewTitle"
           :footer="null"
           @cancel="handleCancel">
    <img alt="example"
         style="width: 100%"
         :src="toUrl(previewImage)" />
  </a-modal>
</template>
<script setup lang="ts">
import { ref, computed, defineEmits, watch } from "vue"
import { ImageCustomizeEditor as ImageCustomizeViewer } from '@iota-cn/ui-components'
import { toUrl, verifyUploadImgName } from "../../../../utils/index"
import { createComment, updateComment } from "../api/index"
import { type UploadChangeParam, message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  item: any
  isDivider: boolean
  isAppend: boolean
  isEdit: boolean
}>()
const emits = defineEmits(['createSuccess'])
const customableImageService = ref<any>()
const bigContainer = ref()
const comment_form = ref({
  rate: 5,
  content: '',
  images: '',
  is_anonymous: false
})
const rate_title = computed(() => {
  let title = t('Comment.CommentContent.goodReview')
  let color = 'green'
  if (comment_form.value.rate == 5 || comment_form.value.rate == 4) {
    title = t('Comment.CommentContent.goodReview')
    color = 'green'
  } else if (comment_form.value.rate == 3 || comment_form.value.rate == 2) {
    title = t('Comment.CommentContent.averageReview')
    color = 'orange'
  } else {
    title = t('Comment.CommentContent.badReview')
    color = 'red'
  }
  return { title, color }
})
const changeRadio = () => {
  comment_form.value.is_anonymous = !comment_form.value.is_anonymous
}
const imgLoading = ref<boolean>(false)
const handleChange = (info: UploadChangeParam) => {
  if (info.file.status === 'uploading') {
    if (fileList.value.length == 5 && fileList.value[4].status != 'uploading') {
      message.error(t('Comment.CommentItem.maxUploadError'))
      return
    } else {
      imgLoading.value = true
    }
    return
  }
  if (info.file.status === 'done') {
    imgLoading.value = false
  }
  if (info.file.status === 'error') {
    imgLoading.value = false
    message.error(t('Comment.CommentItem.uploadError'))
  }
}

const templateBasicParameters = (item: any) => {
  return Object.assign({}, { image: renderImageBaseUrl(item), color: colorOfItem(item)?.value, width: item.spu_custom_width, height: item.spu_custom_height })
}

const assignCustomizedData = computed(() => (item: any) => {

  return Object.assign({},
    { ...(item.spu_custom_areas || {}) },
    { scale: (200 / item.spu_custom_width) * (item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customized_areas.customable_image_scale || item.spu_custom_areas.scale) },
    item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customized_areas.boundingRect || {})
})

// 临时解决方案 接口返回的customizedImages顺序不一致 order排序以后 sql太长不生效 加入 separate: true会丢失custom spu id 导致数据为空 
const theFirstCustomizedArea = (record: any) => {
  if (record.customSpu && record.customSpu.customizedImages && record.customSpu.customizedImages.length)
    return record.customSpu.customizedImages.reduce((minIdx: number, curr: any, idx: number, array: any[]) => {
      return curr.custom_area_id < array[minIdx].custom_area_id ? idx : minIdx
    }, 0)
  else return 0
}

const renderImageBaseUrl = (record: any) => {
  const baseHeightRatio = Math.round(record.spu_custom_height * (200 / record.spu_custom_width))
  return toUrl(record.spu_customable_image) + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

const renderImageCustomUrl = (record: any) => {
  if (!record.customized_areas)
    return

  const scaleRatio = record.customized_areas.customable_image_scale || record.spu_custom_areas.scale
  // const heightRatio = Math.round((record.customized_areas.boundingRect.height || record.spu_custom_areas.height) * (200 / record.spu_custom_width) * scaleRatio)
  const widthRatio = Math.round((record.customized_areas.boundingRect.width || record.spu_custom_areas.width) * (200 / record.spu_custom_width) * scaleRatio)
  const renderCustomUrl = toUrl(record.image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`

  return renderCustomUrl
}
const colorOfItem = (item: any): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return customableImageService.value?.convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}
const fileList = ref<any>([])
const previewVisible = ref(false)
const previewImage = ref('')
const previewTitle = ref('')
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
  previewTitle.value = ''
}
const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
const handleCancel = () => {
  previewVisible.value = false
  previewTitle.value = ''
  previewImage.value = ''
}
const submitComment = async () => {
  if (!comment_form.value.content) {
    return message.error(t('Comment.CommentItem.noReviewError'))
  }
  const imageArr = [] as any
  fileList.value?.forEach((file: any) => {
    imageArr.push(file.status == 'done' ? file.response.uploaded : file.url)
  })
  comment_form.value.images = imageArr.join()
  const data = {
    spu_id: props.item.spu_id, order_item_id: props.item.id, parent_id: null
  }
  props.isAppend ? data.parent_id = props.item.comments[0].id : ''
  const id = props.isEdit ? props.item.comments[0].id : ''
  const params = Object.assign(comment_form.value, data)
  if (props.isEdit) {
    await updateComment(id, params).then(() => {
      message.success(t('Comment.CommentItem.editSuccess'))
    })
  } else {
    await createComment(params)
      .catch((err) => {
        message.error(err.message)
      })
    emits('createSuccess')
  }
}
watch(() => props.item, () => {
  if (props.isEdit) {
    comment_form.value.content = props.item.comments[0].content
    comment_form.value.rate = props.item.comments[0].rate
    comment_form.value.is_anonymous = props.item.comments[0].is_anonymous
    fileList.value = []
    if (props.item.comments[0].images.length > 0) {
      const images = props.item.comments[0].images.split(',')
      images.forEach((img: string) => {
        fileList.value.push({
          url: toUrl(img)
        })
      })
    }
  }
  if (props.isAppend) {
    comment_form.value.content = ''
    fileList.value = []
  }
}, {
  immediate: true,
  deep: true
})

</script>
<style scoped lang="less">
.comment-item {
  display: flex;

  .item-spu {
    margin-right: 40px;
    text-align: center;
    font-weight: bold;
    color: #111111;
    line-height: 50px;
  }

  .hidden {
    width: 250px;
    height: 250px;
    position: absolute;
    visibility: hidden;
    display: block;
  }

  .viewer {
    width: 250px;
    height: 250px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;

    // :deep(.fabric-div) {
    //   width: 250px!important;
    //   height: 250px!important;
    // }

    @-moz-document url-prefix() {
      :deep(.fabric-div) {
        width: 250px !important;
        height: 250px !important;
      }

      :deep(.canvas-container) {
        width: 250px !important;
        height: 250px !important;
      }

      :deep(.lower-canvas) {
        width: 250px !important;
        height: 250px !important;
      }

      :deep(.upper-canvas) {
        width: 250px !important;
        height: 250px !important;
      }
    }
  }

  .item-form {
    flex: 1;

    .rate-title {
      display: inline-block;
      margin-left: 20px;
    }

    .green {
      color: #00C939;
    }

    .orange {
      color: #EA9A00;
    }

    .red {
      color: #DC2020;
    }

    .item-upload {
      margin-top: 10px;
      width: auto;
    }

    .upload-tip {
      font-size: 14px;
      color: #999999;
      margin-bottom: 5px;
    }
  }
}

.comment-btn {
  width: 120px;
  height: 40px;
  margin-left: 20px;
}
</style>